import styled from 'styled-components'

import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const TitleSection = styled(TitleSectionBase)`
    background-color: ${(props) => props.theme.color[props.mode === 'Dark' ? 'p600' : 'g100']};
`
